import { ICefSharpCardReader } from "Infrastructure/services/cefSharpService/local/Interfaces/ICefSharpCardReader";

export const StartCardReaderUseCase = async (
  service: ICefSharpCardReader,
  cashlessCode?: string
) => {
  return await service.startCardReader(cashlessCode);
};
